export default __webpack_public_path__ + "static/media/kitchen5-afterA.7df9b5f7.jpg";